var map = {
	"./SGCB.jpg": 17900,
	"./abb.jpg": 12880,
	"./abbank.jpg": 41370,
	"./acb.jpg": 65483,
	"./acbbank.jpg": 44825,
	"./agr.jpg": 30631,
	"./agribank.jpg": 31472,
	"./bab.jpg": 73522,
	"./bacabank.jpg": 33904,
	"./baovietbank.jpg": 42409,
	"./bidv.jpg": 48664,
	"./bvbank.jpg": 523,
	"./cake.jpg": 4589,
	"./clickpay.jpg": 59563,
	"./coopbank.jpg": 72880,
	"./dab.jpg": 48568,
	"./directbank.jpg": 15600,
	"./dongabank.jpg": 64332,
	"./dragondirect.jpg": 3411,
	"./dragonpay.jpg": 90176,
	"./eib.jpg": 72945,
	"./eximbank.jpg": 27374,
	"./fastpay.jpg": 78589,
	"./fpay.jpg": 68609,
	"./fpayautobanking.jpg": 8944,
	"./fpaydirectpay.jpg": 20194,
	"./gamewallet.jpg": 92116,
	"./hdb.jpg": 3595,
	"./hdbank.jpg": 28487,
	"./help2pay-1.jpg": 99694,
	"./help2pay.jpg": 49520,
	"./icb.jpg": 78707,
	"./intelpay.jpg": 97931,
	"./kienlongbank.jpg": 82384,
	"./klb.jpg": 25428,
	"./lienvietpostbank.jpg": 85529,
	"./lpbank.jpg": 9223,
	"./maritimebank.jpg": 57485,
	"./mb.jpg": 25804,
	"./mbb.jpg": 26044,
	"./mbbank.jpg": 57414,
	"./militarybank.jpg": 94506,
	"./mopay.jpg": 46767,
	"./msb.jpg": 67047,
	"./nab.jpg": 79518,
	"./namabank.jpg": 12958,
	"./ncb.jpg": 31316,
	"./ocb.jpg": 24937,
	"./oceanbank.jpg": 19365,
	"./ojb.jpg": 60422,
	"./onepay.jpg": 61875,
	"./onepaydirect.jpg": 4788,
	"./onepaymomo.jpg": 44131,
	"./onepayscratch.jpg": 56637,
	"./paywell.jpg": 44051,
	"./pgb.jpg": 64322,
	"./pgbank.jpg": 64944,
	"./pvb.jpg": 30029,
	"./pvcombank.jpg": 44406,
	"./qipay.jpg": 1733,
	"./qrcode.jpg": 5719,
	"./sacombank.jpg": 70628,
	"./saigonbank.jpg": 11332,
	"./scb.jpg": 64365,
	"./seab.jpg": 7832,
	"./seabank.jpg": 97266,
	"./shb.jpg": 77984,
	"./shinhan.jpg": 88544,
	"./shinhanbank.jpg": 242,
	"./smartpay.jpg": 96470,
	"./stb.jpg": 5220,
	"./tcb.jpg": 15218,
	"./techcombank.jpg": 44300,
	"./tienphongbank.jpg": 23013,
	"./timo.jpg": 51400,
	"./tpb.jpg": 25811,
	"./tpbank.jpg": 94303,
	"./v8pay.jpg": 54145,
	"./vab.jpg": 98534,
	"./vcb.jpg": 45692,
	"./vib.jpg": 14862,
	"./vietabank.jpg": 8390,
	"./vietbank.jpg": 84535,
	"./vietcombank.jpg": 53468,
	"./vietinbank.jpg": 98490,
	"./viettelmoney.jpg": 2508,
	"./viettin.jpg": 18536,
	"./vnpay.jpg": 303,
	"./vnpay1.jpg": 34146,
	"./vnpaymomo.jpg": 26047,
	"./vnpayqr.jpg": 23522,
	"./vnpayzalo.jpg": 63707,
	"./vnptmoney.jpg": 96265,
	"./vp.jpg": 43787,
	"./vpb.jpg": 3537,
	"./vpbank.jpg": 84345,
	"./vtb.jpg": 26853
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83746;